import { styled } from 'styled-components';

export const MainContainer = styled.div`
  margin: 0;
  padding: 0;
`;
